<div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-lg">
    <div class="text-center">
      <h3 class="text-lg font-medium text-gray-900 mb-4">Confirmar eliminación</h3>
      <div class="bg-white p-4 rounded-lg shadow mb-6">
        <div class="flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-gray-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
          </svg>
          <span class="text-lg font-semibold">**** {{cardLastFourDigits}}</span>
        </div>
      </div>
      <p class="text-gray-600 mb-6">
        ¿Estás seguro que deseas eliminar esta tarjeta?
      </p>
      <div class="flex justify-center gap-4">
        <button
          (click)="onClose()"
          class="p-3 bg-gray-200 text-gray-800 rounded-full hover:bg-gray-300 transition duration-200 flex items-center justify-center"
          [disabled]="isLoading"
          aria-label="Cancelar"
          >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <button
          (click)="deleteCard()"
          class="p-3 bg-red-500 text-white rounded-full hover:bg-red-600 transition duration-200 flex items-center justify-center"
          [disabled]="isLoading"
          aria-label="Eliminar"
          >
          @if (!isLoading) {
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </span>
          }
          @if (isLoading) {
            <span class="flex items-center justify-center">
              <svg class="animate-spin h-6 w-6" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </span>
          }
        </button>
      </div>
    </div>
  </div>
</div>
